import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs/Subscription';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';

import { AuthenticationService } from '../shared/authentication.service';
import { EventService } from './../shared/event.service';
import { PublicAccessTerminalService } from '../shared/public-access-terminal.service';
import { SessionTimeoutService } from './../shared/session-timeout.service';

@Component({
  selector: 'app-session-timeout-warning',
  templateUrl: './session-timeout-warning.component.html',
  styleUrls: ['./session-timeout-warning.component.less']
})
export class SessionTimeoutWarningComponent {

  countdownPeriodInSeconds = 120;
  private intervalSubscription: Subscription;
  secondsLeft: number;
  isPAT = this.publicAccessTerminalService.isPublicAccessTerminal();

  constructor(private authenticationService: AuthenticationService,
              private bsModalRef: BsModalRef,
              private eventService: EventService,
              private publicAccessTerminalService: PublicAccessTerminalService,
              private router: Router,
              private sessionTimeoutService: SessionTimeoutService) {
    this.sessionTimeoutService.stop();

    // reset the countdown
    this.secondsLeft = this.countdownPeriodInSeconds;

    let ticker = IntervalObservable.create(1000);
    this.intervalSubscription = ticker.subscribe(
      (count) => {
        let secondsElapsed = count + 1;
        if (secondsElapsed >= this.countdownPeriodInSeconds) {
          if (this.isPAT) {
            this.clearHistory();
          } else {
            this.logOut();
          }
        } else {
          this.secondsLeft = (this.countdownPeriodInSeconds - secondsElapsed);
        }
      }
    );
   }

  keepSessionAlive(): void {
    this.sessionTimeoutService.start();
    this.intervalSubscription.unsubscribe();
    this.bsModalRef.hide();
  }

  clearHistory(): void {
    this.intervalSubscription.unsubscribe();
    this.eventService.clearHistory();
  }

  private logOut(): void {
    this.intervalSubscription.unsubscribe();

    if (this.authenticationService.isUserLoggedIn()) {
      this.authenticationService.logOut();
    }
    this.bsModalRef.hide();
    this.router.navigateByUrl('/logout;reason=inactivity');
    this.eventService.sessionTimedOut();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/session-timeout-warning/session-timeout-warning.component.ts